module.exports = __webpack_public_path__ + "media/images/logo-568-be70168e8c01fab2caa87509ac5c91ac.jpg";